import { useEffect, useRef } from 'react';
import { AVATAR_H, AVATAR_W, drawAvatar, type AvatarLook } from '../art/avatar';

export function AvatarPreview({ look, scale = 3 }: { look: AvatarLook; scale?: number }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = AVATAR_W * scale * dpr;
    canvas.height = AVATAR_H * scale * dpr;
    const c = canvas.getContext('2d')!;
    c.setTransform(scale * dpr, 0, 0, scale * dpr, 0, 0);
    c.clearRect(0, 0, AVATAR_W, AVATAR_H);
    drawAvatar(c, look);
  }, [look, scale]);
  return <canvas ref={ref} style={{ width: AVATAR_W * scale, height: AVATAR_H * scale }} aria-label="Character preview" role="img" />;
}
